export const smartRound = (number: number, fractionDigits = 0) => {
  return number % 1 === 0 ? Math.round(number) : parseFloat(number.toFixed(fractionDigits))
}
